const useIsFormInstancePreview = (): boolean => {
    const windowUrl = window.location.search;
    const params = new URLSearchParams(windowUrl);
    // is formId is defined in the URL, it means it comes from a CosmoLex user
    return !!params.get('formId') && window.location.href.includes('/forms/');
};
export default useIsFormInstancePreview;
